import type { APISharedProfileResponse } from '@see-stella/types'
import { sDayJs } from '@see-stella/utils'
import { describeChange } from './format'
import './sections.css'

/** Every routine change as one dated timeline, newest first. */
export function ChangeLogSection({
  profile,
}: {
  profile: APISharedProfileResponse
}) {
  if (profile.markers.length === 0) return null
  const ordered = [...profile.markers].sort(
    (a, b) => sDayJs(b.date).valueOf() - sDayJs(a.date).valueOf()
  )
  return (
    <section className='analysis'>
      <h2 className='sec-h'>Change log</h2>
      <p className='sec-sub'>Every routine change, newest first.</p>
      <div className='card pad'>
        <ul className='timeline timeline--log'>
          {ordered.map((m, i) => (
            <li className='tl-item' key={i}>
              <span className='tl-node' aria-hidden='true' />
              <span className='tl-date'>
                {sDayJs(m.date).format('MMM D, YYYY')}
              </span>
              <span className='tl-text'>{describeChange(m)}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
